import { render } from "./issue.vue?vue&type=template&id=1b0b4c7c&scoped=true"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"

import "./issue.vue?vue&type=style&index=0&id=1b0b4c7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b0b4c7c"

export default script